import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const getHomeData = async () => {
    try {
        const res = await axiosInstance.get(
            `/home`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getBannerData = async (pageName) => {
    try {
        const res = await axiosInstance.get(
            `/banner/${pageName}`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getCapabilityData = async () => {
    try {
        const res = await axiosInstance.get(
            `/home/capability`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postAboutUs = async (form) => {
    try {
        const {
            title, subTitle, image, description, buttonText, experience
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("buttonText", buttonText);
        formData.append("experience", experience);
        formData.append("description", description);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/home/about`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postServicearea = async (form) => {
    try {
        const {
            title, subTitle, image, description
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("description", description);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/home/service`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postMarketarea = async (form) => {
    try {
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(
            `/home/market`,
            form,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postNewMarketArea = async (form) => {
    try {
        const {
            title, image, description, id
        } = form;

        const formData = new FormData();

        if (id)
            formData.append("id", id);
        formData.append("title", title);
        formData.append("description", description);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/home/market/area`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const deleteMarketAera = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/home/market/area/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const postProjectAnalystics = async (form) => {
    try {
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(
            `/home/analytics`,
            form,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postCapability = async (form,capabilityPage) => {
    try {
        const data = {
            capability: form,
            ...capabilityPage
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/home/capability`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;
    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};